<script>
    let focused = 'home';

    const navItems = [
        {
            nav: '',
            icon: `<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.4002 11.6994H18.5746C18.4017 11.6994 18.2366 11.7683 18.1144 11.8892L16.2931 13.7118C15.9928 14.0121 15.4884 13.9471 15.2726 13.5805C12.3853 8.65086 12.8013 9.36197 12.2371 8.39736C11.8068 7.66287 10.798 7.53416 10.1961 8.13606L9.54736 8.78347L9.55776 8.80167L6.84986 11.5096C6.72766 11.6305 6.56256 11.6994 6.38966 11.6994H2.60016V3.89937C2.60016 3.18177 3.18256 2.59937 3.90016 2.59937H22.1002C22.8178 2.59937 23.4002 3.18177 23.4002 3.89937V11.6994ZM23.4002 22.0996C23.4002 22.8172 22.8178 23.3996 22.1002 23.3996H3.90016C3.18256 23.3996 2.60016 22.8172 2.60016 22.0996V14.2996H7.46866C7.64156 14.2996 7.80666 14.2307 7.92886 14.1098L10.3209 11.7165C10.6212 11.4149 11.1256 11.4799 11.3414 11.8478C14.1988 16.7254 13.6294 15.7491 14.3561 17.001C14.7838 17.7381 15.7939 17.8707 16.3971 17.2688L19.1895 14.4894C19.3104 14.3672 19.4755 14.2996 19.6471 14.2996H23.4002V22.0996ZM23.4 0H2.6C1.1635 0 0 1.1635 0 2.6V23.4C0 24.8352 1.1635 26 2.6 26H23.4C24.8365 26 26 24.8352 26 23.4V2.6C26 1.1635 24.8365 0 23.4 0Z" />
</svg>
`,
            title: 'stats',
        },
        {
            nav: '',
            icon: `<svg width="22" height="26" viewBox="0 0 22 26" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" fill="inherit" d="M19.1578 22.1848C19.1578 22.9402 18.5447 23.2631 17.7894 23.2631H16.4209C15.6656 23.2631 15.0525 22.9402 15.0525 22.1848V20.8164C15.0525 19.3043 13.8278 17.7895 12.3157 17.7895H9.57888C8.06679 17.7895 6.84206 19.3043 6.84206 20.8164V22.1848C6.84206 22.9402 6.22901 23.2631 5.47365 23.2631H4.10524C3.34987 23.2631 2.73682 22.9402 2.73682 22.1848V11.1513C2.73682 10.9693 2.80935 10.7955 2.93661 10.6669L9.96614 3.63874C10.5012 3.10369 11.3674 3.10369 11.9011 3.63874L18.958 10.6943C19.0852 10.8229 19.1578 10.9967 19.1578 11.1773V22.1848ZM21.8946 10.4343C21.8946 10.0717 21.7509 9.72548 21.4964 9.46822L12.8768 0.806172C11.8094 -0.265294 10.0756 -0.269399 9.00415 0.797962L0.402313 9.37106C0.145052 9.62832 0 9.9759 0 10.3399V23.5533C0 25.0654 1.22473 26 2.73682 26H6.84206C8.35415 26 9.57888 25.0654 9.57888 23.5533V22.1849C9.57888 21.4295 10.1919 20.8165 10.9473 20.8165C11.7027 20.8165 12.3157 21.4295 12.3157 22.1849V23.5533C12.3157 25.0654 13.5404 26 15.0525 26H19.1578C20.6699 26 21.8946 25.0654 21.8946 23.5533V10.4343Z"/>
</svg>`,
            title: 'home',
        },
        {
            nav: '',
            icon: `<svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.8437 27H5.15717C4.09758 27 3.31514 25.9545 3.71478 24.993C5.56906 20.547 9.9253 18 14.9997 18C20.0756 18 24.4318 20.547 26.2861 24.993C26.6858 25.9545 25.9033 27 24.8437 27ZM8.87498 8.99995C8.87498 5.69094 11.6235 2.99994 14.9998 2.99994C18.3776 2.99994 21.1245 5.69094 21.1245 8.99995C21.1245 12.3089 18.3776 15 14.9998 15C11.6235 15 8.87498 12.3089 8.87498 8.99995ZM29.9335 26.454C28.8203 21.4155 25.3384 17.697 20.7555 16.0095C23.184 14.094 24.6004 10.9965 24.0798 7.60497C23.4765 3.67047 20.1354 0.521966 16.1022 0.0629655C10.5348 -0.571535 5.81261 3.67347 5.81261 8.99998C5.81261 11.835 7.15393 14.361 9.24555 16.0095C4.66115 17.697 1.18075 21.4155 0.066036 26.454C-0.338199 28.2855 1.1685 30 3.08096 30H26.9186C28.8326 30 30.3393 28.2855 29.9335 26.454Z"/>
</svg>`,
            title: 'profile',
        },
    ];
</script>

<style>
    #bottom-navigation {
        width: 100%;
        max-width: 430px;
        margin: auto;
        position: fixed;
        /* margin-bottom: 47px; */
        bottom: -1px;
        z-index: 10;
        background: var(--background-colour);
    }
    ul {
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
    }
    li {
        fill: var(--nav-colour);
        cursor: pointer;
    }
    .focus {
        fill: var(--nav-focus-colour);
        position: relative;
        cursor: initial;
    }

    .focus::after {
        position: absolute;
        content: '';
        width: 4px;
        border-radius: 100%;
        height: 4px;
        background: var(--nav-focus-colour);
        bottom: -10px;
        left: calc(50% - 2px);
    }
</style>

<nav id="bottom-navigation">
    <ul>
        {#each navItems as navItem}
            <li class={focused === navItem.title ? 'focus' : ''} on:click={() => (focused = navItem.title)}>
                {@html navItem.icon}
            </li>
        {/each}
    </ul>
</nav>
